import { render } from "./contentArticle.vue?vue&type=template&id=3fb77e1e"
import script from "./contentArticle.vue?vue&type=script&lang=js"
export * from "./contentArticle.vue?vue&type=script&lang=js"

import "./contentArticle.vue?vue&type=style&index=0&id=3fb77e1e&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__